import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import SalesInfo from "./salesInfo";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../../assets/images/Girlush Logo.png";
import { Helmet } from "react-helmet-async";
import moment from "moment";
const Sales = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const outlet_id = localStorage.getItem("outlet_id");
  const codeRef = useRef(null);
  const [selectedMode, setSelectedMode] = useState("cash");
  const [reward, setReward] = useState(0);
  const [op, setOp] = useState(false);
  const [returnAmnt, setReturnAmnt] = useState(""); // return bill id
  const [netTotal, setNetTotalAmnt] = useState(""); // return bill id
  const [enableRedeem, setEnableRedeem] = useState(false);
  const [count, setCount] = useState(0);
  const [member, setMember] = useState(false)
  const [subCatName, setSubCatName] = useState("");
  const [billPoints, setBillPoints] = useState({
    total: 0,
    defaultPoint: 0,
  });
  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    salesManId: null,
  });
  const [thisBill, setThisBill] = useState(0);
  const [data, setData] = useState([]);
  const [docName, setDocName] = useState("");
  const [docNameDefault, setDocNameDefault] = useState("");

  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const [postData, setPostData] = useState({
    docdate: "",
    amount: "",
    subtotal_amount: "",
    gst_per: 0,
    gst_amt: "",
    cess_per: 0,
    cess_amt: "",
    roff: "",
    is_credit: 0,
    salesman_id: "",
    mode: "",
    company_id: 1,
    mobile: "",
    party_name: "",
    address: "",
    gst_in: "",
    outletid: outlet_id,
    loyalty_earned: 0,
    loyalty_redem: 0,
    balance_points: 0,
    return_amount: "",
    return_billno: "",
    outlet_sales_details: [],
    card_amount: "",
    cash_amount: "",
    upi_amount: "",
    transaction_id: "",
    transaction_provider: 1,
    transaction_type: 1,
    less_amount: 0,
    discount_amount : 0,
  });


  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet><title>Outlet Sales / Issue</title></Helmet>
      <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
        <Grid className="flex justify-between items-center">
          <Avatar variant="square" src={Logo} onClick={() => navigate("/dashboard")} sx={{ cursor: "pointer" }}/>
          <Typography fontWeight={600} ml={1} onClick={() => navigate("/dashboard")} sx={{ cursor: "pointer", fontSize: 20 }} >GIRLUSH</Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>Outlet Sales</Typography>
        <Typography>Press F11 to Full Screen </Typography>
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid className="w-5/6"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "calc(100% - 40px)",
          }}
        >
          <Grid className="border-b" sx={{ height: "fit-content" }}>
            <SalesInfo
              setPostData={setPostData}
              postData={postData}
              reward={reward}
              ref={codeRef}
              setReward={setReward}
              op={op}
              data={data}
              setOp={setOp}
              billPoints={billPoints}
              setBillPoints={setBillPoints}
              setThisBill={setThisBill}
              thisBill={thisBill}
              setDocName={setDocName}
              setDocNameDefault={setDocNameDefault}
              docName={docName}
              setReturnAmnt={setReturnAmnt}
              returnAmnt={returnAmnt}
              poDetails={poDetails}
              setPoDetails={setPoDetails}
              setEnableRedeem={setEnableRedeem}
              enableRedeem={enableRedeem}
              count={count}
              subCatName={subCatName}
              setMember={setMember}
              selectedMode={selectedMode}
              setSelectedMode={setSelectedMode}
              netTotal={netTotal}
            />
          </Grid>
          <Grid className="p-2 " sx={{ flex: 1 }}>
            <BillingTable
              data={data}
              setData={setData}
              code={code}
              setCode={setCode}
              ref={codeRef}
              setPostData={setPostData}
              postData={postData}
              docName={docName}
              poDetails={poDetails}
              setCount={setCount}
              setSubCatName={setSubCatName}
            />
          </Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo
              data={data}
              postData={postData}
              setPostData={setPostData}
              reward={reward}
              setReward={setReward}
              op={op}
              billPoints={billPoints}
              docName={docName}
              setBillPoints={setBillPoints}
              setThisBill={setThisBill}
              thisBill={thisBill}
              setReturnAmnt={setReturnAmnt}
              returnAmnt={returnAmnt}
              docNameDefault={docNameDefault}
              enableRedeem={enableRedeem}
              member={member}
              selectedMode={selectedMode}
              
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Sales;
